// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jgfn","controls":"styles_controls__2ix-k","charLimit":"styles_charLimit__3-I6W","input":"styles_input__127aa","send":"styles_send__2NVAd"};